import { useMemo } from 'react';
import type { WorkflowDefinitionResponse } from '@erp/rpc';

interface WorkflowRunStepMetadata {
  stepNames: Map<string, string>;
  stepTypes: Map<string, string>;
  stepCategories: Map<string, string>;
  stepConfigs: Map<string, Record<string, unknown>>;
}

export function useWorkflowRunStepMetadata(
  steps?: WorkflowDefinitionResponse['steps'],
): WorkflowRunStepMetadata {
  return useMemo(() => {
    const stepNames = new Map<string, string>();
    const stepTypes = new Map<string, string>();
    const stepCategories = new Map<string, string>();
    const stepConfigs = new Map<string, Record<string, unknown>>();

    for (const step of steps ?? []) {
      stepNames.set(step.id, step.name);
      stepTypes.set(step.id, step.type);
      stepCategories.set(step.id, step.category);
      stepConfigs.set(step.id, step.config);
    }

    return {
      stepNames,
      stepTypes,
      stepCategories,
      stepConfigs,
    };
  }, [steps]);
}
